import { useState, useEffect } from "react";
import axios from "axios";
import { apiRoutes } from "../../constants";

const useCheckProfileQuota = () => {
  const [profileQuotaExceeded, setProfileQuotaExceeded] = useState(false);
  const [profileInfoLoading, setProfileInfoLoading] = useState(false);
  const token = localStorage.getItem("access_token");

  const config = {
    headers: {
      Authorization: `JWT ${token}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    fetchProfileInfo();
  }, []);

  const fetchProfileInfo = async () => {
    setProfileInfoLoading(true);
    try {
      const response = await axios.get(apiRoutes.profileInfo, config);
      setProfileQuotaExceeded(response?.data?.data?.attributes?.isQuotaExceed);
    } catch (error) {
      console.error("Error fetching profile info:", error);
    } finally {
      setProfileInfoLoading(false);
    }
  };

  return { profileQuotaExceeded, profileInfoLoading };
};

export default useCheckProfileQuota;
